import template from './integrations.html';
import controller from './integrations.controller';

let integrationsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default integrationsComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/integrations.component.js